var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 79,
    viewBox: "0 0 90 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.52 2.96489L88.9113 36.5351H88.8874C89.9395 38.3762 89.9395 40.6238 88.8874 42.4649L69.4961 76.0351C68.444 77.8762 66.4833 79 64.3792 79H25.6205C23.5163 79 21.5557 77.8762 20.5036 76.0351L1.11229 42.4649C0.0602277 40.6238 0.0602277 38.3762 1.11229 36.5351L20.5036 2.96489C21.5557 1.12379 23.5163 0 25.6205 0H64.4031C66.5072 0 68.4679 1.12379 69.52 2.96489ZM11.9437 39.5C11.9437 57.7675 26.7442 72.5681 45.0118 72.5681C63.2793 72.5681 78.0799 57.7675 78.0799 39.5C78.0799 21.2324 63.2793 6.4319 45.0118 6.4319C26.7442 6.4319 11.9437 21.2324 11.9437 39.5ZM15.123 39.5002C15.123 23.002 28.5128 9.61222 45.011 9.61222C61.5092 9.61222 74.899 23.002 74.899 39.5002C74.899 55.9984 61.5092 69.3882 45.011 69.3882C28.5128 69.3882 15.123 55.9984 15.123 39.5002ZM19.905 39.4763C19.905 53.3444 31.1429 64.5822 45.011 64.5822C58.879 64.5822 70.1169 53.3444 70.1169 39.4763C70.1169 25.6083 58.879 14.3704 45.011 14.3704C31.1429 14.3704 19.905 25.6083 19.905 39.4763Z",
    fill: "#9E9FAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGrey);
export default __webpack_public_path__ + "static/media/logo--grey.cd82292a8cafdd029974be9f14b3f527.svg";
export { ForwardRef as ReactComponent };